const PATHS = {
  menu: (
    <>
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </>
  ),
  home: <path d="M3 12l9-8 9 8M5 10v10h14V10" />,
  chev_right: <polyline points="9 18 15 12 9 6" />,
  chev_left: <polyline points="15 18 9 12 15 6" />,
  chev_down: <polyline points="6 9 12 15 18 9" />,
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <line x1="12" y1="2" x2="12" y2="4" />
      <line x1="12" y1="20" x2="12" y2="22" />
      <line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
      <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
      <line x1="2" y1="12" x2="4" y2="12" />
      <line x1="20" y1="12" x2="22" y2="12" />
      <line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
      <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
    </>
  ),
  moon: <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />,
  stop: (
    <>
      <circle cx="12" cy="12" r="10" />
      <rect x="9" y="9" width="6" height="6" rx="1" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-7 8-7s8 3 8 7" />
    </>
  ),
  map: (
    <>
      <polygon points="3 6 9 4 15 6 21 4 21 18 15 20 9 18 3 20 3 6" />
      <line x1="9" y1="4" x2="9" y2="18" />
      <line x1="15" y1="6" x2="15" y2="20" />
    </>
  ),
  sliders: (
    <>
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <circle cx="4" cy="12" r="2" />
      <circle cx="12" cy="10" r="2" />
      <circle cx="20" cy="14" r="2" />
    </>
  ),
  plane: (
    <path d="M17.8 19.2L16 11l3.5-3.5a1 1 0 0 0 0-1.4l-1.8-1.8a1 1 0 0 0-1.4 0L12.8 8l-8.2-1.8c-.5-.1-1 .2-1.2.7L2.7 8.1c-.2.5 0 1.1.4 1.4L8 13.3l-2.8 2.8-2.1-.7c-.4-.1-.8.1-1 .4l-.6.9a.5.5 0 0 0 .5.7l2.8 1 1 2.8a.5.5 0 0 0 .7.5l.9-.6c.3-.2.5-.6.4-1l-.7-2.1 2.8-2.8 3.8 4.9c.3.4.9.6 1.4.4l1.2-.7c.5-.2.8-.7.7-1.2z" />
  ),
  train: (
    <>
      <rect x="5" y="2" width="14" height="15" rx="3" />
      <line x1="5" y1="10" x2="19" y2="10" />
      <circle cx="9" cy="13.5" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="15" cy="13.5" r="1.5" fill="currentColor" stroke="none" />
      <path d="M8.5 17l-2 5M15.5 17l2 5" />
    </>
  ),
  hotel: (
    <>
      {/* Base stradale dell'hotel */}
      <path d="M3 21h18" />
      {/* Struttura principale dell'edificio con angoli arrotondati in alto */}
      <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
      {/* Finestre geometriche e allineate */}
      <path d="M9 7h6" />
      <path d="M9 11h6" />
      <path d="M9 15h6" />
      {/* Porta d'ingresso ad arco */}
      <path d="M10 21v-4a2 2 0 0 1 4 0v4" />
    </>
  ),
  car: (
    <>
      <path d="M19 10l-1.7-4.3A2 2 0 0 0 15.4 4H8.6a2 2 0 0 0-1.9 1.7L5 10" />
      {/* Scocca principale */}
      <rect x="3" y="10" width="18" height="8" rx="2" />
      {/* Fari anteriori simmetrici */}
      <circle cx="7" cy="14" r="1" />
      <circle cx="17" cy="14" r="1" />
      {/* Ruote/Supporti inferiori */}
      <path d="M5 18v2" />
      <path d="M19 18v2" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="8" y1="3" x2="8" y2="7" />
      <line x1="16" y1="3" x2="16" y2="7" />
    </>
  ),
  sparkles: (
    <>
      <path d="M12 2l2 5 5 2-5 2-2 5-2-5-5-2 5-2z" />
      <path d="M19 14l1 3 3 1-3 1-1 3-1-3-3-1 3-1z" transform="translate(-3 0)" />
    </>
  ),
  check: <polyline points="20 6 9 17 4 12" />,
  x: (
    <>
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </>
  ),
  plus: (
    <>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </>
  ),
  alert: (
    <>
      <path d="M12 2l10 18H2z" />
      <line x1="12" y1="9" x2="12" y2="14" />
      <circle cx="12" cy="17" r="0.7" fill="currentColor" />
    </>
  ),
  edit: (
    <>
      <path d="M12 20h9M16.5 3.5l4 4-12 12H4.5v-4z" />
    </>
  ),
  save: (
    <>
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </>
  ),
  handover: (
    <>
      <path d="M9 11l3 3 8-8" />
      <path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="8" />
      <line x1="12" y1="11" x2="12" y2="16" />
    </>
  ),
  arrow_left: (
    <>
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="11 6 5 12 11 18" />
    </>
  ),
  arrow_right: (
    <>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="13 6 19 12 13 18" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </>
  ),
  eye: (
    <>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  photo: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="8.5" cy="10" r="1.5" />
      <path d="M21 15l-5-5L5 21" />
    </>
  ),
  paperclip: (
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  ),
  mic: (
    <>
      <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3z" />
      <path d="M19 10v1a7 7 0 0 1-14 0v-1" />
      <line x1="12" y1="19" x2="12" y2="23" />
      <line x1="8" y1="23" x2="16" y2="23" />
    </>
  ),
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
    </>
  ),
  flag: <path d="M4 21V4h13l-2 4 2 4H4" />,
  bolt: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
  ban: (
    <>
      <circle cx="12" cy="12" r="9" />
      <line x1="5.6" y1="5.6" x2="18.4" y2="18.4" />
    </>
  )
}

export const Icon = ({ name, size = 16, className, style }) => {
  const inner = PATHS[name]
  if (!inner) return null
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {inner}
    </svg>
  )
}
